<script>
import options from './StafetAddMoreDeltagerFlow.options'
export default options
</script>

<template>
  <article
    class="kb-stafet-donation-flow__step kb-stafet-add-more-deltager-flow"
  >
    <StafetHeader
      :steps="[]"
      :title="labels.title"
      :description="labels.description"
    />

    <div class="kb-stafet-step">
      <StafetAddDeltager
        :labels="labels"
        :displayInputError="displayInputError"
        :onChangeCallback="updateAddParticipants"
        :data="participants"
        :excludeMail="true"
      />
    </div>

    <StafetPayment
      :title="labels.yourInformationTotalTitle"
      :basket="basket"
      :inTotalLabel="labels.yourInformationTotal"
      :inTotalPrice="basketTotalPrice.toString()"
    />

    <StafetActions
      :nextStepCallback="goToPayment"
      :nextStepLabel="labels.formNavigationLastStep"
    />
  </article>
</template>
